import {
  Fullscreen as MaximiseIcon,
  FullscreenExit as MinimiseIcon
} from '@material-ui/icons';
import React, { useState } from 'react';

import Tooltip from '../../../components/common/StyledToolTip';
import styles from './styles';
import { withStyles } from '@material-ui/core';

const Fullscreen = ({ classes, toggleFullscreen }) => {
  const [isMaximized, setIsMaximized] = useState(false);

  const updateIsMaximized = () => {
    const updatedIsMaximized = !isMaximized;
    setIsMaximized(updatedIsMaximized);
    toggleFullscreen(updatedIsMaximized);
  };

  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
      onClick={updateIsMaximized}>
      <Tooltip title={isMaximized ? 'Minimize' : 'Maximize'}>
        {isMaximized ? <MinimiseIcon /> : <MaximiseIcon />}
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(Fullscreen);
